
import { TenantSystemPrefs, UserPermissions } from "@/store/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
@Component({})
export default class InteractiveConsole extends Vue {
    @Getter("getFeature") private getFeature: (featureName: string[]) => boolean;
    @Getter("getPermissions") private getPermissions: UserPermissions;
    @State("tenantSystemPrefs") private tenantSystemPrefs: TenantSystemPrefs;

    private phoneNumber: string = "";
    private showIframe: boolean = true;

    private get interactiveConsoleURL(): string {
        return this.tenantSystemPrefs.interactiveConsoleURL;
    }

    @Watch("interactiveConsoleURL")
    private reloadIfFrame(): void {
        this.showIframe = false;
        this.$nextTick(() => {
            this.showIframe = true;
        });
    }

    private get canAccessInteractiveConsole(): boolean {
        return this.getFeature(["InteractiveConsole"]) && this.getPermissions.canAccessInteractiveConsole;
    }

    private get isUrlValid(): boolean {
        try {
            if (!this.interactiveConsoleURL) {
                return false;
            }

            new URL(this.interactiveConsoleURL);
            return true;
        } catch (e) {
            return false;
        }
    }

    private validatePhoneNumber(phoneNumber: string): boolean {
        const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format
        return phoneRegex.test(phoneNumber);
    }

    public makeCall(iframe: boolean = false) {
        if (!this.validatePhoneNumber(this.phoneNumber)) {
            this.$notify({
                type: "error",
                title: "Invalid Phone Number",
                text: "Please enter a valid phone number in E.164 format (e.g., +1234567890)."
            });
            return;
        }

        const kvps = { };
        const data = {
            phoneNumber: this.phoneNumber,
            display: "0",
            kvps: kvps
        };

        const icJsonRequest = {
            name: "makeCall",
            data: data
        };

        if (iframe) {
            if (this.$refs.icIframe) {
                (document.getElementById('icIframe') as HTMLIFrameElement).contentWindow.postMessage(icJsonRequest, "*");
            } else {
                console.error("IC frame is not open.");
            }
        } 
    }
}
